import styles from "./SoldOutOverlay.module.css";

export default function SoldOutOverlay() {
  return (
    <div className={styles.overlay} aria-hidden="true">
      <span className={styles.text}>SOLD OUT</span>
    </div>
  );
}

export function PackageCardLink({
  href,
  soldOut = false,
  className,
  children,
  ...rest
}) {
  if (soldOut) {
    return (
      <div className={className} aria-disabled="true" {...rest}>
        {children}
      </div>
    );
  }

  return (
    <a href={href} className={className} {...rest}>
      {children}
    </a>
  );
}
